module.exports = __webpack_public_path__ + "img/visa.ab3dc9b1.svg";